import { fetcher } from '@commenda/utils';
import { TTPDocumentRecord } from './types';

type AttachFileResult =
  | { ok: true; data: TTPDocumentRecord }
  | { ok: false; error: string };

const attachFileToTPDocument = async (
  recordId: string,
  fileUrl: string,
  fileName: string
): Promise<AttachFileResult> => {
  const res = await fetcher(`tp-document-record/${recordId}/attach-file`, {
    method: 'POST',
    body: { fileUrl, fileName },
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to attach file' };
  }

  const data = (await res.json()) as TTPDocumentRecord;
  return { ok: true, data };
};

export { attachFileToTPDocument };
export type { AttachFileResult };
